export const INIT_RESTAURANT = "INIT_RESTAURANT";
export function initRestaurant(data) {
    return { type: INIT_RESTAURANT, data }
};



// WEBPACK FOOTER //
// ./src/services/store/reducers/restaurant/actions.js